<template>
  <div class="tree-item" v-if="!item.isRemove">
    <div class="tree-item-box">
      <folder-icon :item="item"></folder-icon>
      <div @click="changeTreeNodeSelectedItem(item);" class="tree-item" :class="{ 'is-not-using': item.isDisabled }">
        <div
          :ref="`treeItem${item.id}`"
          :class="{ bold: isFolder,
           'box': true,
           'isFocus': isSelectedItem,
           large: item.type === 'large',
           medium: item.type === 'medium',
           small: item.type === 'small' }"
          @dblclick="makeFolder">
          <div class="tree-item-content">
            <div class="item-content-box" :class="item.type">
              <span class="tree-item-type">{{ getTitle(item.type) }}</span>&nbsp;<span class="tree-item-name">{{ item.name }}</span>
            </div>
            <remove-icon :item="item" v-if="item.isRemoveBtn"></remove-icon>
          </div>
        </div>
      </div>
      <add-icon :item="item" :class="item.type !== 'small' ? 'visible': 'hidden'"></add-icon>
    </div>
    <div v-show="isOpen">
      <tree-item
        class="tree-item-box"
        v-for="(child, index) in item.children"
        :key="index"
        :item="child"
        @make-folder="$emit('make-folder', $event)"
        @add-item="$emit('add-item', $event)"
      ></tree-item>
    </div>
  </div>
</template>

<script>
import FolderIcon from './folderIcon'
import AddIcon from './addIcon'
import RemoveIcon from './removeIcon'
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'treeItem',
  components: {RemoveIcon, AddIcon, FolderIcon},
  props: {
    item: Object
  },
  computed: {
    ...mapGetters(['treeNodeSelectedItem']),
    isSelectedItem () {
      return this.item.id === this.treeNodeSelectedItem.id
    },
    isFolder () {
      return this.item.children &&
        this.item.children.length
    },
    isOpen () {
      return this.item.isOpen
    }
  },
  methods: {
    ...mapMutations([
      'changeTreeNodeSelectedItem'
    ]),
    getTitle (type) {
      if (this.item.isProMent) {
        if (type === 'large') {
          return '[大分類]'
        }
        if (type === 'medium') {
          return '[中分類]'
        }
        return '[小分類]]'
      } else {
        return ''
      }
    },
    makeFolder () {
      if (!this.isFolder) {
        this.$emit('make-folder', this.item)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tree-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  &.is-not-using {
    opacity: 0.3;
    background-color: #FFFFFF;
  }

  .visible {
    visibility: visible;
  }

  .hidden {
    visibility: hidden;
  }

  .tree-item-box {
    position:relative;
    display: flex;
    justify-content: flex-end;
  }

  .folder-icon-box {
    margin-right: 5px;
    padding-top:7px;
    align-items: flex-start;
    color: #919191;
  }

  .delete-icon-box {
    position: absolute;
    top:0;
    right:3px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .delete-icon {
    color: #FF7875;

    &:before {
      display: flex;
      flex: 1 1 auto;
      justify-content: flex-end;
    }
  }

  .add-icon-box {
    margin-left: 5px;
    padding-bottom:4px;
    display: flex;
    align-items: center;
    color: #ff8c8c;
  }

  .add-icon {
    color: #ff8c8c;
  }

  .tree-item-content {
    display: flex;
    justify-content: flex-start;
    flex: 1 1 auto;
    .item-content-box {
      flex: 1 1 auto;
      max-width: 200px;
      word-break: break-all;
      &.medium {
        max-width: 180px;
      }

      &.small {
        max-width: 150px;
      }
    }
  }

  .box {
    position:relative;
    display: flex;
    flex: 1 1 auto;
    background-color: #FFFFFF;
    border-radius: 3px;
    border: 1px solid #BEBEBE;
    margin-bottom: 4px;
    padding: {
      top: 6px;
      bottom: 6px;
      left: 10px;
      right: 10px;
    }
    &.isFocus {
      border: 1px solid #ff8c8c;
    }

    .tree-item-type {
      color: #919191;
    }

    .tree-item-name {
      color: #414141;
    }

    &.large {
      width: 100%;
    }

    &.medium {
      width: 230px;
    }

    &.small {
      width: 205px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agent/components/treeItem.vue